import AutenticacaoService from "./servicesApi/AutenticacaoService";
import EmpresaService from "./servicesApi/EmpresaService";
import UsuarioService from "./servicesApi/UsuarioService";
import PrazoService from "./servicesApi/PrazoService";
import NotificacaoService from "./servicesApi/NotificacaoService";
import CEPService from "./servicesApi/CEPService";

const Services = {
  AutenticacaoService,
  EmpresaService,
  UsuarioService,
  PrazoService,
  NotificacaoService,
  CEPService
}

export default Services;
